import faker from 'faker'
import services from './service-type'

export default generateList(15)

function generateList(length = 1) {
  const list = []
  for (let i = 1; i <= length; i++) {
    list.push({
      id: i,
      domains: getDomains(),
      service_type: getServiceId(),
      key: faker.random.uuid(),
      blocked: faker.random.boolean(),
      created: faker.date.past()
    })
  }
  return list
}

function getDomains() {
  const domains = []
  const number = getRandomInt(1, 4)
  for (let i = 0; i < number; i++) {
    domains.push(faker.internet.domainName())
  }
  return domains.join(',')
}

function getServiceId() {
  const serviceIds = services.map(service => service.id)
  const index = getRandomInt(0, serviceIds.length - 1)
  return serviceIds[index]
}

function getRandomInt(min, max) {
  const { round, random } = Math
  return round(random() * (max - min)) + min
}



// WEBPACK FOOTER //
// ./src/server/fixtures/keys.js